// Textos de la ficha de usuario del backoffice (user-detail). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'en',
  data: {
    USER_DETAIL: {
      BACK: 'Back to users',
      LOADING: 'Loading user…',
      LOAD_ERROR: 'The user could not be loaded.',
      COMMON: {
        VERIFIED: 'Verified',
        UNVERIFIED: 'Unverified',
        CANCEL: 'Cancel',
        ACCEPT: 'OK',
        ERROR: 'Error',
        CLOSE: 'Close',
      },
      BREADCRUMB: {
        ARIA: 'Breadcrumb',
        USERS: 'WAIIS users',
        DETAIL: 'Detail',
      },
      SUPPORT_CHAT_PICK: {
        TITLE: 'Which chat do you want to open?',
        PRIVATE: 'Private chat',
        PRIVATE_SUB: 'Only the user and support',
        PRIVATE_NEW_SUB: "Doesn't exist yet: created when you open it",
        GROUP: 'Trip group chat',
        GROUP_NAMED: 'Group chat · {{name}}',
        LAST_ACTIVITY: 'Last activity {{when}}',
        CANCEL: 'Cancel',
      },
      HERO: {
        PHOTO_ALT: 'User photo',
        BANNED: 'Blocked',
        VERIFIED: 'Identity verified',
        DOCUMENT_VERIFIED: 'Document verified',
        SIGNUP: 'Joined',
        EDIT: 'Edit',
        SUPPORT_CHAT: 'Support chat',
        BAN: 'Block account',
        UNBAN: 'Unblock',
      },
      BAN: {
        STATUS_TITLE: 'Account blocked',
        SINCE: 'since {{date}}',
        EDIT_REASON: 'Edit reason',
        INTERNAL_NOTE_HINT: 'Internal note (not visible to the user)',
        REASONS: {
          PAYMENT_ISSUE: {
            TITLE: 'Non-payment or payment issue',
            BODY: 'This is due to an outstanding issue related to a payment.',
          },
          USER_REPORT: {
            TITLE: 'Report from another user',
            BODY: 'This is due to an issue reported by another member of the community.',
          },
          RULES_VIOLATION: {
            TITLE: 'Breach of the rules',
            BODY: 'This is due to a breach of the Waiis terms of use.',
          },
          ACCOUNT_REVIEW: {
            TITLE: 'Our team is reviewing your account.',
            BODY: 'We have detected a problem that we need to look into.',
          },
        },
        MODAL_TITLE: 'Block {{name}}\'s account',
        MODAL_TITLE_NEW: 'Block the account',
        MODAL_TITLE_EDIT: 'Edit the block',
        MODAL_INTRO: 'The user will lose access to the app and will see a screen with this reason, in their own language. Their active routines are paused until the account is unblocked. The text cannot be edited: choose the case that applies.',
        REASON_LABEL: 'Reason',
        REASON_REQUIRED: 'Choose the reason for the block.',
        NOTE_LABEL: 'Internal note (optional)',
        NOTE_PLACEHOLDER: 'Details of the case for the team. The user does not see this.',
        NOTE_COUNT: '{{count}}/500 characters',
        PREVIEW_LABEL: 'This is what the user will see, translated into their language',
        PREVIEW_TITLE_EMPTY: 'Choose a reason',
        PREVIEW_BODY_EMPTY: 'Here you will see the text the user reads.',
        SAVE_CHANGES: 'Save changes',
        BAN_ACCOUNT: 'Block account',
        UPDATED_TITLE: 'Reason updated',
        UPDATED_TEXT: 'The user will see the new reason on the blocked screen.',
        BANNED_TITLE: 'Account blocked',
        BANNED_TEXT: 'The user will see the blocked screen with the stated reason.',
        UNBAN_TITLE: 'Unblock account',
        UNBAN_TEXT: 'The user will regain access to the app immediately.',
        UNBAN_BUTTON: 'Unblock',
        UNBAN_DONE_TITLE: 'Account unblocked',
        UNBAN_DONE_TEXT: 'The user can use the app again.',
        ERROR_BAN: 'The account could not be blocked',
        ERROR_UNBAN: 'The account could not be unblocked',
        ERROR_RETRY: 'Please try again.',
      },
      METRICS: {
        BALANCE: 'Current balance',
        BALANCE_SUB: 'In the user\'s wallet',
        COLLECTED: 'Collected from passengers',
        COLLECTED_SUB: 'Total as driver',
        DRIVER_TRIPS: 'Trips as driver',
        RIDER_TRIPS: 'Trips as passenger',
        SUCCESS: '{{percent}}% success',
        CREDITS: 'Credits',
        CREDITS_SUB: 'Credit balance',
        PROFILE_COMPLETED: 'Profile completed',
        PROFILE_COMPLETED_SUB: 'Email, phone, document and selfie',
        ARIA: 'User indicators',
      },
      PENDING: {
        TITLE: 'Pending money',
        SUBTITLE: 'What still has to come into or go out of the balance from trips, referrals and promotions.',
        KPI: 'Pending',
        KPI_SUB: 'Will come into or out of the balance',
        KPI_NEXT: 'Next: {{date}}',
        KPI_NO_DATE: 'No date',
        KPI_NOTHING: 'Nothing pending',
        KPI_CTA: 'See in “Pending” →',
        KPI_CTA_ON: '✓ In “Pending”',
        NET: 'Net',
        REFRESH: 'Refresh',
        LOAD_ERROR: 'Couldn\'t load what this user has pending.',
        RETRY: 'Retry',
        EMPTY: 'Nothing pending to come into or out of the balance.',
        INFO_NOTE: '“Informative” rows don\'t count towards the net: the withdrawal has already left the balance and a charged trip only comes back if it fails.',
        NO_DATE: 'No date',
        NEXT_CREDIT: 'On the next credit',
        BEFORE: 'Before {{date}}',
        RANGE: '{{from}} → {{to}}',
        PROGRESS: '{{done}}/{{required}} trips',
        UNKNOWN_PERSON: 'No name',
        GROUP: { IN: 'Coming in', OUT: 'Going out', INFO: 'Informative (not in the net)' },
        COL: { CONCEPT: 'Concept', REASON: 'Reason', WHEN: 'When', AMOUNT: 'Amount', OPEN: 'Open the tab' },
        TYPE: {
          TRIP_VERIFYING: 'Being verified · {{count}} trips',
          TRIP_DEFERRED: 'Deferred · {{count}} trips',
          TRIP_IDENTITY: 'Passenger identity · {{count}} trips',
          PVP_CAE_REFUND: 'CAE bonus refund (PVP)',
          REFERRAL: 'Referral · {{name}}',
          REFERRAL_CODE: 'Code {{code}} · {{name}}',
          PVP_PROMO: 'PVP promo',
          TRIP_PROMO: 'Trip promo',
          INCENTIVE: 'Company incentive',
          PENALTY_IN: 'Penalty in their favour',
          PENALTY_OUT: 'Pending penalty',
          PENALTY_DEBT: 'Penalty debt · {{count}}',
          REJECTED_CHARGE: 'Declined charge · {{count}} trips',
          UNSETTLED_CHARGE: 'Charged, trip to come · {{count}}',
          WITHDRAWAL_HELD: 'Held withdrawal · {{count}}',
        },
        DETAIL: {
          TRIP_VERIFYING: 'Estimated; comes in when the trip is valid',
          TRIP_DEFERRED_REINFORCED: 'Credit deferred by the reinforced check',
          TRIP_DEFERRED_CASH: 'Credit deferred based on history and amount',
          TRIP_IDENTITY: 'The passenger hasn\'t verified their ID yet',
          PVP_CAE_REFUND: 'If they verify their ID before the deadline',
          REFERRAL: {
            PENDING: 'Waiting for the conditions',
            PENDING_TRIPS: 'Verified trips missing',
            PENDING_VERIFICATION: 'ID not verified yet',
            PENDING_REGISTRATION: 'Not registered yet',
          },
          REFERRAL_CODE: 'On the invitee\'s first verified trip',
          PVP_PROMO: '2 trips over 10 km',
          TRIP_PROMO: 'When they complete the promo trips',
          INCENTIVE: 'When they complete the campaign task',
          PENALTY_IN: 'The other party cancelled; if no substitute is found',
          PENALTY_OUT: 'Late cancellation',
          PENALTY_DEBT: 'Deducted from the next credits',
          REJECTED_CHARGE: 'Card declined; negative balance if the trip is verified',
          UNSETTLED_CHARGE: 'Already out of the balance; comes back if the trip is undone or not verified',
          WITHDRAWAL_HELD: 'Already out of the balance; will reach the bank',
        },
        REASON: {
          VERIFYING: 'Verification',
          REINFORCED: 'Reinforced',
          CASH_DELAY: 'Review',
          MANUAL_REVIEW: 'Manual review',
          IDENTITY: 'Identity',
          REFERRAL: 'Referral',
          PROMO: 'Promotion',
          INCENTIVE: 'Incentive',
          PENALTY: 'Penalty',
          REJECTED: 'Declined',
          UPCOMING_TRIP: 'Trip to come',
          OTHER: 'Other',
        },
      },
      TABS: {
        ARIA: 'User section',
        PROFILE: 'Profile',
        TRIPS: 'Trips',
        PENDING: 'Pending',
        MOVEMENTS: 'Transactions',
        NEW_MOVEMENT: 'New transaction',
      },
      IDENTITY: {
        TITLE: 'Identity',
        ID: 'ID',
        FULL_NAME: 'Full name',
        DOCUMENT: 'Document',
        DOCUMENT_TYPE: 'Document type',
        BIRTH_DATE: 'Date of birth',
        SIGNUP_DATE: 'Sign-up date',
      },
      CONTACT: {
        TITLE: 'Contact',
        EMAIL: 'Email',
        PHONE: 'Phone',
        ADDRESS: 'Address',
        APP_LANGUAGE: 'App language',
      },
      PERMISSIONS: {
        TITLE: 'Device permissions',
        SUB: 'What the app can use on the user\'s phone.',
        ALLOWED: 'Allowed',
        DENIED: 'Denied',
        NOTIFICATIONS: 'Notifications',
        LOCATION: 'Location',
        BACKGROUND_LOCATION: 'Background location',
        PHYSICAL_ACTIVITY: 'Physical activity',
        BLUETOOTH: 'Bluetooth',
        AND: ' and ',
        CANNOT_VERIFY: 'Their trips cannot be verified: {{missing}} missing.',
        CAN_VERIFY: 'Their trips can be verified.',
      },
      PVP: {
        TITLE: 'Full price bonus',
        FRAUD_TAG: 'Fraud',
        SUB: 'If they complete 2 verified trips of over 10 km at full price (PVP), the amount is credited to their wallet.',
        FRAUD_CONSEQUENCE: 'Once paid, they move to reinforced verification + no cost 0.',
        IN_PROGRESS: 'In progress',
        COMPLETED: 'Completed',
        ACTIVATED_BY: 'Activated by {{name}} on {{date}}',
        LAST_CANCELLED: 'Last one cancelled on {{date}}',
        NONE: 'No promotion',
        CANCEL: 'Cancel promotion',
        ACTIVATE: 'Activate PVP promotion',
        LOADING: 'Loading…',
        NO_PROMO_IN_PROGRESS: 'No promotion in progress',
        PROGRESS: '{{done}} of {{total}} trips',
        STEP_INACTIVE: 'Not activated',
        STEP_ACTIVATED: 'Activated',
        STEP_TRIP: 'Trip {{n}}',
        STEP_TRIP_DONE: 'done',
        STEP_PAID: 'Credited',
        STEP_TRIP_TITLE: 'Verified trip of over 10 km at PVP',
        STEP_TRIP_TITLE_DATE: 'Verified trip of over 10 km at PVP ({{date}})',
        STEP_ACTIVATED_TITLE: 'Activated by {{name}}',
        STEP_PAID_TITLE: '{{amount}} in the wallet once the trips are completed',
        MODAL_TITLE: 'Activate PVP promotion',
        MODAL_INTRO: 'How much are you offering {{name}}? It is credited to their wallet once they complete 2 verified trips of over 10 km at PVP from now on.',
        HINT_START: 'The starting offer.',
        HINT_COMPLAINT: 'If they complain or threaten to leave.',
        OFFER_OTHER: 'Offer another amount',
        OTHER_LABEL: 'Another amount',
        OTHER_PLACEHOLDER: 'e.g. 4',
        OTHER_HINT: 'Only if they do not accept 3 € or 5 €.',
        OTHER_REMOVE: 'Remove other amount',
        CONFIRM: 'Confirm',
        ACTIVATED_TITLE: 'Promotion activated',
        ACTIVATED_TEXT: 'Once they complete 2 trips at PVP, {{amount}} will be credited to them.',
        ERROR_ACTIVATE: 'The promotion could not be activated',
        ERROR_CANCEL: 'The promotion could not be cancelled',
        ERROR_403: 'You do not have permission to manage this user\'s promotion',
        CANCEL_TITLE: 'Cancel the promotion?',
        CANCEL_TEXT: 'The user will no longer be eligible for the bonus. You can activate another one later.',
        CANCEL_YES: 'Yes, cancel',
        CANCEL_NO: 'No',
        CANCELLING: 'Cancelling…',
        CANCEL_DONE: 'Cancelled',
      },
      TRIP: {
        TITLE: 'Trip promo',
        SUB: 'Choose the amount, number of trips, minimum km (from 10), whether they are full price or cost 0 and whether they count as driver, passenger or both. Once completed (verified) the amount is added to their wallet. They can have several in progress.',
        SUB_ACTIVE: 'After {{count}} verified trip(s) of over {{km}} km {{type}} the amount is added to their wallet.',
        IN_PROGRESS: 'In progress',
        COMPLETED: 'Completed',
        TYPE_PVP: 'at full price',
        TYPE_WITHOUT_COST: 'at cost 0',
        TYPE_ANY: 'full price or cost 0',
        TYPE_BADGE_PVP: 'Full price trips',
        TYPE_BADGE_WITHOUT_COST: 'Cost 0 trips',
        TYPE_BADGE_ANY: 'Any',
        TYPE_HINT_PVP: 'Only full price trips count.',
        TYPE_HINT_WITHOUT_COST: 'Only trips free for the passenger count.',
        TYPE_HINT_ANY: 'Both full price and cost 0 trips count.',
        ACTIVATED_BY: 'Activated by {{name}} on {{date}}',
        LAST_CANCELLED: 'Last one cancelled on {{date}}',
        NONE: 'No promo',
        CANCEL: 'Cancel promo',
        ACTIVATE: 'Activate trip promo',
        LOADING: 'Loading…',
        NO_PROMO_IN_PROGRESS: 'No promo in progress',
        PROGRESS: '{{done}} of {{total}} trips',
        STEP_INACTIVE: 'Not active',
        STEP_ACTIVATED: 'Activated',
        STEP_TRIP: 'Trip {{n}}',
        STEP_TRIP_DONE: 'done',
        STEP_PAID: 'Paid',
        STEP_TRIP_TITLE: 'Verified trip of over {{km}} km {{type}}',
        STEP_TRIP_TITLE_DATE: 'Verified trip of over {{km}} km {{type}} ({{date}})',
        STEP_ACTIVATED_TITLE: 'Activated by {{name}}',
        STEP_PAID_TITLE: '{{amount}} in the wallet once the trips are done',
        MODAL_TITLE: 'Activate trip promo',
        FIELD_AMOUNT: 'Amount',
        FIELD_ROUTES: 'Number of trips',
        FIELD_KM: 'Minimum km per trip',
        KM_HINT: 'Never less than {{min}} km.',
        KM_OTHER: 'Other km',
        ROUTES_OTHER: 'Other number of trips',
        CHIP_OTHER: 'Other',
        TYPE_CHIP_PVP: 'Full price',
        TYPE_CHIP_WITHOUT_COST: 'Cost 0',
        TYPE_CHIP_ANY: 'Any',
        KM_CHANGE: 'Change minimum km ({{km}} km)',
        FRAUD_NOTE: 'It does not affect their fraud status.',
        CONFIRM_SUMMARY: 'Activate · {{amount}} for {{count}} trip(s)',
        PROGRESS_LAST: 'Last trip: {{date}}',
        PROGRESS_NONE: 'No trips yet',
        PROGRESS_PAID: 'Paid {{date}}',
        ADD_ANOTHER: 'Add another promo',
        FIELD_USER: 'User',
        USER_SEARCH_PLACEHOLDER: 'Search name, email or phone…',
        USER_SEARCH_HINT: 'Type at least 2 letters to search.',
        USER_SEARCHING: 'Searching…',
        USER_NOT_FOUND: 'No user matches.',
        USER_CHANGE: 'Change user',
        FIELD_ROLE: 'Who counts',
        ROLE_ANY: '',
        ROLE_DRIVER: 'as a driver',
        ROLE_RIDER: 'as a passenger',
        ROLE_CHIP_ANY: 'Driver or passenger',
        ROLE_CHIP_DRIVER: 'Driver only',
        ROLE_CHIP_RIDER: 'Passenger only',
        ROLE_BADGE_ANY: 'Driver or passenger',
        ROLE_BADGE_DRIVER: 'Driver only',
        ROLE_BADGE_RIDER: 'Passenger only',
        PRESET_HINT: '€3: 2 trips as driver or passenger, full price or free. €5: 2 trips as driver only, full price. You can change any field.',
        PICK_PROMO: 'Promo to show',
        FIELD_TYPE: 'Trip type',
        OTHER_LABEL: 'Other amount',
        OTHER_PLACEHOLDER: 'Other',
        CONFIRM: 'Confirm',
        ACTIVATED_TITLE: 'Promo activated',
        ACTIVATED_TEXT: 'After {{count}} trip(s) of over {{km}} km {{type}} they will get {{amount}}.',
        ERROR_ACTIVATE: 'The promo could not be activated',
        ERROR_CANCEL: 'The promo could not be cancelled',
        ERROR_403: 'You are not allowed to manage this user\'s promo',
        CANCEL_TITLE: 'Cancel the trip promo?',
        CANCEL_TEXT: 'The user will no longer be eligible for the amount. You can activate another one later.',
        CANCEL_YES: 'Yes, cancel',
        CANCEL_NO: 'No',
        CANCELLING: 'Cancelling…',
        CANCEL_DONE: 'Cancelled',
      },
    },
  },
};
